/**
 * 归一化后端 data-conf 的布尔值（字符串 "false" 为 truthy，需显式转换）
 * @param {boolean|string} val
 * @returns {boolean}
 */
export const toBool = (val) => val === true || val === "true";

/**
 * 检查数字是否为空
 * @param {number|string|boolean|undefined|null} num - 需要检查的数字
 * @returns {boolean} - 如果数字为空，则返回 true，否则返回 false
 */
export const isNumEmpty = (num) => {
  if (['', false, undefined, null].includes(num)) {
    return true;
  }
  if (isNaN(num)) {
    return true;
  }
  return false;
}


/**
 * 格式化产品型号
 * 去除型号字符串中的空格并转换为大写
 * 
 * @param {string} modelNumber 产品型号
 * @returns {string} 格式化后的产品型号
 */
export const formatModelNumber = (modelNumber) => {
  return !modelNumber ? "" : String(modelNumber).replace(/\s+/g, "").toUpperCase();
};


/**
 * 
 * 
 * @returns {string}
 */
export const getLang = () => {
  return  document?.documentElement?.lang ?? 'en';
};

